import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Configs from "../config"
import StaffIndex from "pages/Staff/Index"
import LocationIndex from "pages/Locations"
import ServicesIndex from "pages/Services/Index"
import RolesIndex from "pages/Roles/Index"
import Leaves from "pages/Leaves"
import Calender from "pages/Calender/Calender"
import Notifications from "pages/Notifications"
import PayrollReport from "pages/PayrollReport"
import AttendanceReport from "pages/AttendanceReport"
import UserQuery from "pages/UserQuery"
import ProfilePage from "pages/Profile"
import VerifyCode from "pages/Authentication/VerifyOTP"
import ResetPassword from "pages/Authentication/ResetPassword"
import Reports from "pages/Reports"
import PayrollHistory from "pages/PayrollHistory"
import HelpSection from "pages/Helpsection"
import Product from "pages/Product/Index"
import Supplier from "pages/Supplier/Index"
import Order from "pages/Order/Index"

const authProtectedRoutes = [
  { path: `${Configs.appurl}dashboard`, component: <Dashboard /> },

  // Staff
  { path: `${Configs.appurl}staff`, component: <StaffIndex /> },

  // Location
  { path: `${Configs.appurl}locations`, component: <LocationIndex /> },

  // Roles
  { path: `${Configs.appurl}roles`, component: <RolesIndex /> },

  // Attendance Report
  {
    path: `${Configs.appurl}payroll-report`,
    component: <PayrollReport />,
  },

  { path: `${Configs.appurl}payroll-history`, component: <PayrollHistory /> },
  {
    path: `${Configs.appurl}attendance-report`,
    component: <AttendanceReport />,
  },

  // Leave Management
  {
    path: `${Configs.appurl}leave-management`,
    component: <Leaves />,
  },

  // Services
  { path: `${Configs.appurl}services`, component: <ServicesIndex /> },
  { path: `${Configs.appurl}notifications`, component: <Notifications /> },
  { path: `${Configs.appurl}calender`, component: <Calender /> },

  { path: `${Configs.appurl}user-query`, component: <UserQuery /> },
  { path: `${Configs.appurl}profile`, component: <ProfilePage /> },
  { path: `${Configs.appurl}daily-report`, component: <Reports /> },
  { path: `${Configs.appurl}help-section`, component: <HelpSection /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name

  // Inventory Management
  { path: `${Configs.appurl}product-catalog`, component: <Product /> },
  { path: `${Configs.appurl}supplier`, component: <Supplier /> },
  { path: `${Configs.appurl}orders`, component: <Order /> },

  {
    path: `${Configs.appurl}`,
    exact: true,
    component: <Navigate to="dashboard" />,
  },
]

const publicRoutes = [
  { path: `${Configs.appurl}logout`, component: <Logout /> },
  { path: `${Configs.appurl}login`, component: <Login /> },
  { path: `${Configs.appurl}forgot-password`, component: <ForgetPwd /> },
  { path: `${Configs.appurl}register`, component: <Register /> },
  { path: `${Configs.appurl}verify-code`, component: <VerifyCode /> },
  { path: `${Configs.appurl}reset-password`, component: <ResetPassword /> },
]

export { authProtectedRoutes, publicRoutes }
